var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseElSelect',{attrs:{"placeholder":"請選擇","clearable":""},model:{value:(_vm.syncModel),callback:function ($$v) {_vm.syncModel=$$v},expression:"syncModel"}},_vm._l((_vm.allowOptionList),function(nav){return _c('BaseElSelectOption',{key:nav.value,attrs:{"label":nav.name,"value":nav.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }